import React from 'react';
import { Drawer, Timeline, Tag, Collapse, Spin, Typography, Empty } from 'antd';
import type { EvalGroundTruthHistoryEntry } from './evalTypes';

const { Text } = Typography;

const changeTypeColor: Record<string, string> = {
    created: 'green',
    updated: 'blue',
    deleted: 'red',
};

export interface SkillStudioEvalHistoryDrawerProps {
    open: boolean;
    entryId: string | null;
    onClose: () => void;
    loading: boolean;
    history: EvalGroundTruthHistoryEntry[];
}

const SkillStudioEvalHistoryDrawer: React.FC<SkillStudioEvalHistoryDrawerProps> = ({
    open,
    onClose,
    loading,
    history,
}) => {
    return (
        <Drawer
            title="Version History"
            open={open}
            onClose={onClose}
            width={520}
            destroyOnClose
        >
            {loading ? (
                <div style={{ textAlign: 'center', padding: 40 }}>
                    <Spin />
                </div>
            ) : history.length === 0 ? (
                <Empty description="No history found" />
            ) : (
                <Timeline
                    items={history.map((entry) => ({
                        color: changeTypeColor[entry.change_type] ?? 'gray',
                        children: (
                            <div key={entry.version}>
                                <div style={{ marginBottom: 4 }}>
                                    <Tag color={changeTypeColor[entry.change_type]}>
                                        v{entry.version} — {entry.change_type}
                                    </Tag>
                                    <Text type="secondary" style={{ fontSize: 12 }}>
                                        {entry.changed_by ?? 'unknown'} &middot;{' '}
                                        {entry.changed_at
                                            ? new Date(entry.changed_at).toLocaleString()
                                            : ''}
                                    </Text>
                                </div>
                                <Collapse
                                    size="small"
                                    items={[
                                        {
                                            key: '1',
                                            label: 'Snapshot',
                                            children: (
                                                <pre
                                                    style={{
                                                        fontSize: 11,
                                                        maxHeight: 300,
                                                        overflow: 'auto',
                                                        background: '#f5f5f5',
                                                        padding: 8,
                                                        borderRadius: 4,
                                                    }}
                                                >
                                                    {JSON.stringify(
                                                        {
                                                            question_set: entry.question_set,
                                                            question: entry.question,
                                                            ground_truth: entry.ground_truth,
                                                            comments: entry.comments,
                                                            status: entry.status,
                                                        },
                                                        null,
                                                        2,
                                                    )}
                                                </pre>
                                            ),
                                        },
                                    ]}
                                />
                            </div>
                        ),
                    }))}
                />
            )}
        </Drawer>
    );
};

export default SkillStudioEvalHistoryDrawer;
